import { c as _c } from "react/compiler-runtime";
import { getOrgQueryKey, patchOrgMutation } from '@onefootprint/fetch-dashboard';
import { useRequestErrorToast } from '@onefootprint/hooks';
import type { Organization } from '@onefootprint/request-types/dashboard';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import useSession from '@/hooks/use-session';
const useUpdateOrg = () => {
  const $ = _c(7);
  const showErrorToast = useRequestErrorToast();
  const session = useSession();
  const queryClient = useQueryClient();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = patchOrgMutation();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== queryClient || $[2] !== session) {
    t1 = response => {
      queryClient.invalidateQueries({
        queryKey: ["org"]
      });
      queryClient.invalidateQueries({
        queryKey: getOrgQueryKey()
      });
      queryClient.setQueryData(["org"], response);
      queryClient.setQueryData(getOrgQueryKey(), response);
      session.setOrg({
        name: response.name,
        logoUrl: response.logoUrl,
        isSandboxRestricted: response.isSandboxRestricted
      });
    };
    $[1] = queryClient;
    $[2] = session;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== showErrorToast || $[5] !== t1) {
    t2 = {
      ...t0,
      onError: showErrorToast,
      onSuccess: t1
    };
    $[4] = showErrorToast;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useMutation(t2);
};
export default useUpdateOrg;